import { baseApi } from "./baseApi";

/**
 * Categorías globales del sistema (pagos, identidad, tramites, etc.).
 * Las usa CategoryCombobox al crear servicios y Me.tsx para gestionar el listado.
 */
export const categoriesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<string[], void>({
      query: () => "/v1/categories",
      transformResponse: (r: { categories: string[] }) => r.categories,
      providesTags: [{ type: "Stats", id: "categories-LIST" }],
      keepUnusedDataFor: 300,
    }),
    createCategory: builder.mutation<void, string>({
      query: (category) => ({ url: "/v1/categories", method: "POST", body: { category } }),
      invalidatesTags: [{ type: "Stats", id: "categories-LIST" }],
    }),
    deleteCategory: builder.mutation<void, string>({
      query: (category) => ({
        url: `/v1/categories/${encodeURIComponent(category)}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Stats", id: "categories-LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCategoriesQuery,
  useCreateCategoryMutation,
  useDeleteCategoryMutation,
} = categoriesApi;
